import "core-js/modules/es.array.push.js";
import { AuthService } from '@/services/auth.service';
export default {
  name: 'AccountNav',
  props: {
    name: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      navList: [{
        name: 'Patients',
        link: ''
      }, {
        name: 'Doctors',
        link: 'doctors'
      }, {
        name: 'Messages',
        link: 'messages',
        hasBadge: true
      }, {
        name: 'Earnings',
        link: 'earnings'
      }, {
        name: 'Admins',
        link: 'admins'
      }],
      unreadMessagesCount: 0,
      intervalFunction: null
    };
  },
  async created() {
    this.$store.dispatch('auth/getUser');
  },
  destroyed() {
    clearInterval(this.intervalFunction);
  },
  methods: {
    async logOut() {
      await AuthService.logout();
      this.$router.push('/login');
    }
  }
};